/**
 * ExcerptDisplay Component
 *
 * Displays a brief excerpt of text from a source document.
 * Truncates long text with "Show more" expansion capability.
 */

import { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';

interface ExcerptDisplayProps {
  text: string;
  maxLength?: number; // default 200
}

export function ExcerptDisplay({ text, maxLength = 200 }: ExcerptDisplayProps) {
  const [isExpanded, setIsExpanded] = useState(false);

  // Check if text needs truncation
  const needsTruncation = text.length > maxLength;
  const displayText = isExpanded || !needsTruncation ? text : text.slice(0, maxLength) + '...';

  return (
    <div className="border-l-2 border-gray-300 dark:border-gray-600 pl-3 py-1">
      <p className="text-sm text-gray-600 dark:text-gray-400 italic whitespace-pre-wrap">{displayText}</p>
      {needsTruncation && (
        <button
          onClick={() => setIsExpanded(!isExpanded)}
          className="inline-flex items-center gap-1 mt-1 text-xs text-primary-600 dark:text-primary-400 hover:text-primary-700 dark:hover:text-primary-300 font-medium"
        >
          {isExpanded ? (
            <>
              <ChevronUp size={12} />
              Show less
            </>
          ) : (
            <>
              <ChevronDown size={12} />
              Show more
            </>
          )}
        </button>
      )}
    </div>
  );
}
